import { CService, IPropsConfig } from "./class.base.service";

class FileService extends CService{
  store<T = any>(params: any,  config?:IPropsConfig):Promise<T>{
    return this.api.post<any, T>(`/${this.path}`,params, config);
  };
}

const fileService = new FileService("files");
export default fileService